var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.21291C3.99974 2.74335 3.78877 3.25195 3.41351 3.62684C3.03825 4.00172 2.52943 4.21218 1.999 4.21191C1.46857 4.21165 0.959965 4.00068 0.585079 3.62542C0.210194 3.25016 -0.000264966 2.74135 2.50361e-07 2.21091C0.000265467 1.68048 0.211233 1.17188 0.586494 0.796993C0.961754 0.422108 1.47057 0.211649 2.001 0.211914C2.53143 0.21218 3.04004 0.423147 3.41492 0.798408C3.78981 1.17367 4.00027 1.68248 4 2.21291ZM4.06 5.69291H0.0600002V18.2129H4.06V5.69291ZM10.38 5.69291H6.4V18.2129H10.34V11.6429C10.34 7.98291 15.11 7.64291 15.11 11.6429V18.2129H19.06V10.2829C19.06 4.11291 12 4.34291 10.34 7.37291L10.38 5.69291Z",
    fill: "#423F3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e37e68f4cf0cdf620295b675c306ff9c.svg";
export { ForwardRef as ReactComponent };